import React, { useState, useEffect } from 'react';
import { format, startOfWeek, addDays } from 'date-fns';
import es from 'date-fns/locale/es';
import { fetchAusenciasProfesor, fetchGuardiasProfesor } from './Guardias-Api';
import { getUserLoggedLS } from '../../util/LocalStorageUtils';
import './CalendarWeekView.css'; // Importa el archivo CSS

const CalendarWeekView = ({ currentDate, celdasHoradias, openDetailModal, profesorId, timeSlots }) => {
    const [ausenciasSemana, setAusenciasSemana] = useState({});
    const [guardiasSemana, setGuardiasSemana] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchInitialData();
    }, [currentDate, profesorId]);

    const alTerminarCargaGuardias = (data) => {
        console.log("Guardias Semana: ", data);
        setGuardiasSemana(data);
    }

    const alTerminarCargaAusencias = (data) => {
        setAusenciasSemana(data);
        console.log("Ausencias Semana: ", data);
        setLoading(false);
    }
    const fetchInitialData = async () => {
        setLoading(true);
        setError(null);
        try {
            const startDate = startOfWeek(currentDate, { locale: es, weekStartsOn: 1 });
            const endDate = addDays(startDate, 4); // Suponiendo 5 días laborales
            if (!profesorId) {
                let userLogged = getUserLoggedLS();
                profesorId = userLogged.id;
            }
            fetchGuardiasProfesor(profesorId, format(startDate, 'yyyy-MM-dd'), format(endDate, 'yyyy-MM-dd'), alTerminarCargaGuardias);
            fetchAusenciasProfesor(profesorId, format(startDate, 'yyyy-MM-dd'), format(endDate, 'yyyy-MM-dd'), alTerminarCargaAusencias);
        } catch (err) {
            setError('Error al cargar los datos de ausencias y guardias');
            setLoading(false);
        }
    };
    /* const navigateWeek = (offset) => {
            setCurrentDate(prevDate => {
                const newDate = new Date(prevDate);
                newDate.setDate(newDate.getDate() + (7 * offset));
                return newDate;
            });
        }; */

    const daysOfWeek = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'];
    //const timeSlots = [/* ... tu lista de franjas horarias ... */];

    if (loading) {
        return <div>Cargando datos 2...</div>;
    }

    if (error) {
        return <div>Error al cargar los datos: {error.message}</div>;
    }

    return (
        <div>
            {/* Tabla semanal */}
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead className="table-light sticky-header">
                        <tr>
                            <th className="sticky-column">Hora</th>
                            {daysOfWeek.map((day, index) => (
                                <th key={index}>
                                    <span>{day}</span><br />
                                    <small>{format(addDays(startOfWeek(currentDate, { locale: es, weekStartsOn: 1 }), index), 'dd/MM')}</small>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {timeSlots.map(franja => (
                            <tr key={franja.id}>
                                <td className="sticky-column">
                                    <small>{`${franja.horaInicio}`}</small>
                                    <small className="text-muted d-block">{franja.descripcion}</small>
                                </td>
                                {daysOfWeek.map((_, dayIndex) => {
                                    const weekStart = startOfWeek(currentDate, { locale: es, weekStartsOn: 1 });
                                    const cellDate = addDays(weekStart, dayIndex);
                                    const currentDateFormatted = format(cellDate, 'yyyy-MM-dd');
                                    const celdaHoraria = celdasHoradias.filter(celda => celda.franjaHorariaId === franja.id && celda.diaSemanaOrden === (dayIndex + 1));
                                    const celdaSeleccionada = celdaHoraria[0];
                                    const ausencia = ausenciasSemana?.filter(a => a.celdaHoraria.id === celdaSeleccionada?.id);
                                    const guardian = Array.isArray(guardiasSemana) ? guardiasSemana.filter(a => a.franjaId === franja.id && a.fecha === currentDateFormatted) : [];
                                    const hayGuardiaAsignada = guardian.length > 0;
                                    const esCeldaGuardia = celdaSeleccionada?.guardia;
                                    const celdaGuardiaId = celdaSeleccionada?.id || guardian[0]?.celdaHoraria?.id;

                                    return (
                                        <td style={{textAlign:'center'}} key={dayIndex} className={`p-2 position-relative ${ausencia.length > 0 ? 'ausencia-card' : ''} ${(esCeldaGuardia || hayGuardiaAsignada) ? 'guardia-card' : ''}`}
                                            onClick={() => { /* Lógica para abrir el modal de detalle */ }}>
                                            {ausencia.length > 0 && (
                                                <>
                                                    <span style={{ color: 'red', fontWeight: 'bold' }}>Ausencia</span><br />
                                                </>
                                            )}
                                            {esCeldaGuardia && (
                                                <>
                                                    {celdaGuardiaId && (
                                                        <>
                                                            <button
                                                            className="btn btn-link p-0"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openDetailModal(cellDate, franja, celdaGuardiaId);
                                                            }}>
                                                                Ver Detalle
                                                            </button>
                                                            <br />
                                                        </>
                                                    )}
                                                    <span style={{ color: 'blue', fontWeight: 'bold' }}>Guardia</span><br />
                                                    {hayGuardiaAsignada ? (
                                                        <span>{guardian[0].celdaHoraria?.aula?.codigo}</span>
                                                    ) : (
                                                        <small className="text-muted">Sin guardias asignadas</small>
                                                    )}
                                                </>
                                            )}
                                            {celdaHoraria.length > 0 && (
                                                <>
                                                    <span>{celdaHoraria[0].aulaCodigo}</span><br />
                                                    <span>{celdaHoraria[0].detalle}</span>
                                                    {/* <span>{celdaHoraria[0].grupos}</span> */}
                                                </>
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Modales */}
            {/* <AbsenceForm /> */}
            {/* <FullDayAbsenceForm /> */}
            {/* <AbsenceDetailModal /> */}
        </div>
    );
};

export default CalendarWeekView;
